import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';

// Import bootstrap css
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
// Import perfect scrollbar css
import 'react-perfect-scrollbar/dist/css/styles.css';
// Import country flags
import 'flag-icon-css/css/flag-icon.css';

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };

  render() {
    return (
      <div className="home-app">
        <PerfectScrollbar className="page-container">{this.props.children}</PerfectScrollbar>
      </div>
    );
  }
}
